export const UPLOAD_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
};
export const filteredExtensions = {
  [UPLOAD_TYPES.IMAGE]: ['jpg', 'jpeg', 'png'],
  [UPLOAD_TYPES.VIDEO]: ['mp4', 'webm']
}; // Copied over from FileManagerUI https://git.hubteam.com/HubSpot/FileManagerUI/blob/fe7fd81ab6d7291f09bf7a58a620429f8181ce90/FileManagerCore/static/js/utils/file.js#L62-L76

export const splitNameAndExtension = file => {
  const name = file.name;
  /* eslint-disable no-useless-escape */

  const matches = name.match(/(.*)\.([^\.]+)$/);
  /* eslint-enable no-useless-escape */

  if (!matches) {
    return {
      extension: '',
      name
    };
  }

  return {
    name: matches[1],
    extension: matches[2].toLowerCase()
  };
};
export const ListingStatus = {
  DRAFT: 'DRAFT',
  IN_REVIEW: 'IN_REVIEW',
  LISTED: 'LISTED',
  // TODO deprecate
  CERTIFIED: 'CERTIFIED',
  // TODO deprecate
  ARCHIVED: 'ARCHIVED',
  // TODO deprecate
  REJECTED: 'REJECTED',
  PUBLISHED: 'PUBLISHED',
  PENDING_UNPUBLISH: 'PENDING_UNPUBLISH'
};
export const MAX_SLUG_LENGTH = 60;
export const APP_LISTING_TABS = {
  info: ['name', 'companyName', 'tagline', 'appUrl', 'iconUrl', 'category', 'categoryFeatures', 'keywords', 'urlPath'],
  details: ['videoUrl', 'screenshots', 'benefits', 'integrationFeatures', 'hubSpotFeatures', 'appIntegrations', 'dataSyncs', 'dataSyncInfo', 'dataSyncHowItWorks', 'appLanguages'],
  pricing: ['agencyPricingUrl', 'currency', 'pricingUrl', 'pricings'],
  support: ['supportUrl', 'email', 'chatUrl', 'companyUrl', 'facebookUrl', 'phone', 'supportLanguages', 'setupUrl', 'supportUrl', 'forumUrl', 'casesUrl', 'termsUrl', 'privacyUrl', 'privacy2Url', 'privacy3Url'],
  review: ['reviewNotes', 'devEmail', 'devFirstName', 'devLastName', 'devPhone', 'pointsOfContact']
};
export const PROFILE_LISTING_TABS = {
  company: ['name', 'websiteUrl', 'logoUrl', 'slug', 'locations', 'description'],
  services: ['services', 'industries', 'regions', 'languages', 'budget']
};
export const THEME_LISTING_TABS = {
  info: ['name', 'pricing', 'exampleUrl', 'thumbnailUrl'],
  details: ['videoUrl', 'screenshots', 'benefits', 'features', 'clientExamples'],
  category: ['pageTypes', 'pageFeatures', 'tags', 'businessTypes'],
  support: ['supportIncluded', 'support', 'answers', 'hours', 'responseTime', 'timezone', 'supportLanguages', 'supportEmail', 'chatUrl', 'facebookUrl', 'phone', 'setupUrl', 'supportUrl', 'forumUrl', 'casesUrl', 'termsUrl', 'privacyUrl', 'privacy2Url', 'privacy3Url'],
  review: ['versionNumber', 'releaseNotes', 'sourceCode']
};
export const SERVICE_LISTING_TABS = {
  info: ['brief', 'headline', 'maxPrice', 'minPrice'],
  details: ['altText', 'description', 'images', 'working', 'videoUrl'],
  studies: [],
  contact: [],
  preview: []
};